import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=70b98d6f&scoped=true&"
import script from "./changeRecord.vue?vue&type=script&lang=js&"
export * from "./changeRecord.vue?vue&type=script&lang=js&"
import style0 from "./changeRecord.vue?vue&type=style&index=0&id=70b98d6f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b98d6f",
  null
  
)

export default component.exports